import { SoftReminderStep } from '@root/query'

export interface PaymentRemindersFormValues {
  is_automatic_debt_collection_enabled: boolean
  soft_reminder_steps: SoftReminderStep[]
  debt_collection_delay_days_company: number
  debt_collection_delay_days_person: number
}

export const lastReminderOverlapsCollection = (values: PaymentRemindersFormValues): boolean => {
  if (!values.is_automatic_debt_collection_enabled) return false
  const steps = values.soft_reminder_steps || []
  if (!steps.length) return false
  const lastDays = Number(steps[steps.length - 1]?.days_after_due)
  const earliestHandoverDays = Math.min(
    Number(values.debt_collection_delay_days_company) || 0,
    Number(values.debt_collection_delay_days_person) || 0
  )
  return Number.isFinite(lastDays) && lastDays >= earliestHandoverDays
}
